import type { App } from 'vue'
import { ref } from 'vue'
import en from './en'
import no from './no'

const messages = {
  en,
  no,
} as const

type Locale = keyof typeof messages
type MessageValue = string | Record<string, MessageValue>

const locale = ref<Locale>('no')

const normalizeLocale = (value: string): Locale => {
  if (value === 'nb' || value === 'no') return 'no'
  if (value === 'en') return 'en'
  return 'no'
}

const getMessage = (lang: Locale, path: string): string | undefined => {
  const segments = path.split('.')
  let current: MessageValue | undefined = messages[lang] as MessageValue

  for (const segment of segments) {
    if (!current || typeof current === 'string') return undefined
    current = (current as Record<string, MessageValue>)[segment]
  }

  return typeof current === 'string' ? current : undefined
}

const t = (key: string): string => {
  return getMessage(locale.value, key) ?? getMessage('en', key) ?? key
}

// Helper function to change locale
const setLocale = (newLocale: Locale) => {
  locale.value = newLocale
  localStorage.setItem('userLanguage', newLocale)
}

// Helper function to get current locale
export const getCurrentLocale = () => locale.value

export const initializeLocale = (rawLocale?: string) => {
  const normalized = normalizeLocale(rawLocale || localStorage.getItem('userLanguage') || 'no')
  setLocale(normalized)
}

export const installI18n = (app: App) => {
  app.config.globalProperties.$t = (key: string) => t(key)
}
